import React, {useState, useEffect} from 'react';
import fieldUtils from './field-utils';
import {TextField, IntegerField} from '../../../libs/react-components-admin/fields/text-like-field';
import FieldWidth from './field-width';
import ConditionId from './condition-id';

const SubtitleField = ({id, conditions, value, onChange}) => {

  const [model, setModel] = useState(value || {});
  const [_conditions, setConditions] = useState(conditions);

  useEffect(() => { onChange(model); }, [model]);
  useEffect(() => { setConditions(conditions); }, [conditions]);

  return <div className="row">
    <div className="col-12">
      <TextField id="subtitle"
                 label="Subtitle"
                 placeholder="Enter a subtitle"
                 value={model.text}
                 onChange={v => setModel({...model, text: v})}/>
    </div>
    <div className="col-12">
      <FieldWidth value={model.widthInPercent}
                  onChange={v => setModel({...model, widthInPercent: v})}/>
    </div>
    <div className="col-12 col-md-6">
      <div className="mb-3">
        <label htmlFor="alignment" className="form-label">Alignment</label>
        <select id="alignment" name="alignment"
                className="form-select"
                value={model.alignment || ''}
                onChange={e => setModel({...model, alignment: e.target.value})}>
          <option key={0} value={''}/>
          {fieldUtils.alignments.map((width, i) => {
            return <option key={i + 1} value={width.value}>{width.label}</option>
          })}
        </select>
        <div className="form-text">Leave blank to use your theme defaults</div>
      </div>
    </div>
    <div className="col-12 col-md-6">
      <IntegerField id="fontSize"
                    label="Font size in pixels"
                    value={model.fontSizeInPx}
                    onChange={v => setModel({...model, fontSizeInPx: v})}/>
    </div>
    <div className="col-12 col-md-6">
      <IntegerField id="marginTop"
                    label="Top margin in pixels"
                    helpBlock="Leave blank to use your theme defaults"
                    value={model.marginTop}
                    onChange={v => setModel({...model, marginTop: v})}/>
    </div>
    <div className="col-12 col-md-6">
      <IntegerField id="marginBottom"
                    label="Bottom margin in pixels"
                    helpBlock="Leave blank to use your theme defaults"
                    value={model.marginBottom}
                    onChange={v => setModel({...model, marginBottom: v})}/>
    </div>
    <div className="col-12">
      <ConditionId id={id}
                   conditions={_conditions}
                   value={model.conditionId}
                   onChange={v => setModel({...model, conditionId: v})}/>
    </div>
  </div>;
};

export default SubtitleField;
